export default __webpack_public_path__ + "static/media/light-honeycomb-dark.be22f003.png";